import { observer } from 'mobx-react-lite';
import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
// import { AuthContext } from "./Auth";
import { useStore } from "./store";

export const PrivateRoute = observer<RouteProps>((props) => {
    const store = useStore()

    if (!!store.auth.user) {
        return <Route {...props} />
    }

    return <Redirect to={"/login"} />
});